import React, { useContext, useEffect } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { JazeelContext } from 'Influencers/utils/JazeelContext'
import CampaignHeader from 'Brands/brandComponents/CampaignHeader'
import SideMenuSection from 'Influencers/influencerComponents/SideMenu/SideMenuSection'
import CampaignRoutes from './CamapignRoutes'
import { RTL } from 'locales/currentLang'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

const CampaignLayout = styled.div`
  font-family:  ${props =>
    props.theme.dir === 'left'
      ? 'Tajawal !important;'
      : 'Montserrat !important;'}
  // direction: ${props => (props.dir === 'true' ? 'rtl' : 'lrt')};
`
export default function CampaignSystem() {
  const { auth, isMobile, mobileMenuOpen, setMobileMenuOpen } = useContext(
    JazeelContext,
  )
  const theme = {
    dir: RTL() ? 'left' : 'right',
    reverseDir: RTL() ? 'right' : 'left',
  }
  const location = useLocation()
  useEffect(() => {
    ReactGA.initialize('UA-176125221-1')
    ReactGA.pageview(location.pathname)
  }, [location])
  return (
    <ThemeProvider theme={theme}>
      <CampaignLayout
        onClick={() => mobileMenuOpen && setMobileMenuOpen(false)}
        // dir={RTL().toLocaleString()}
      >
        <CampaignHeader />
        <SideMenuSection />
        <CampaignRoutes />
      </CampaignLayout>
    </ThemeProvider>
  )
}
